export abstract class LocalStorageService {
    prefix: any;
    abstract get(key: string, defValue?: any, prefix?: string): any;
    abstract put(key: string, data: any, prefix?: string): any;
    abstract remove(key: string, prefix?: string): any;
}

export function LocalStorageServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('LocalStorage');
}

export const LocalStorageServiceProvider = {
    provide: LocalStorageService,
    useFactory: LocalStorageServiceFactory,
    deps: ['$injector']
};
